/**
 * LoggedIn form component.
 *
 * @returns {JSX.Element}
 */
// State action for update/set rule config.
import {useDispatch} from 'react-redux';
import {setRuleConfig} from "@app/modules/PersonaForm/store/PersonaFormStore";
import {useEffect} from "react";

export default function GuestUser() {

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(setRuleConfig(
			{
				id: 'GuestUser',
				config: {
					ruleType: "login",
					args: {
						login_state: false
					},
				}
			}
		));
	}, []);

	return <>
		<p>
			This
			rule
			targets
			guest
			users.
		</p>
	</>;
}
